module.exports = __webpack_public_path__ + "img/cover-keytouch.ab8088e6.jpg";